import { faTrashCan } from '@fortawesome/pro-regular-svg-icons'
import { UploadDocumentType } from '@/constants/businessConstants'
import { useAppDispatch } from '@/utils/typeHelpers'
import { useReselector } from '@/utils/sharedHooks'
import { getUserDocumentsByCategoryInternalName } from '@/features/user/your-practice/documents/lib/userDocuments.selector'
import {
  IAdditionalTrackingProperties,
  useDocumentUpload,
} from '@/components/documents/upload/hooks/useDocumentUpload'
import { destroySingleUserDocument } from '@/features/user/your-practice/documents/lib/userDocuments.slice'
import { UserDocumentCategoryIdentifier } from '@/features/admin/user-document-categories/userDocumentCategory.constants'

import { TypographyStyles, TextColors } from '@/styles'
import { DocumentUploadDialog, Icon, Link, List, Popup, Text } from '@/ui'

interface IUploadItem {
  additionalTrackingProperties: IAdditionalTrackingProperties
  cardDescription?: string
  children?: React.ReactNode
  documentCategory: UserDocumentCategoryIdentifier
  documentType?: UploadDocumentType
  label: string
  popUpContent?: React.ReactNode
  uploadProps?: {
    year?: string
  }
  uploadButtonOnly?: boolean
}

// TBD potentially reusabled/replacement for FileUploadFormInput comp
export const UploadItem = ({
  additionalTrackingProperties,
  children,
  documentCategory,
  documentType = UploadDocumentType.TAX,
  label,
  popUpContent,
  uploadProps = {},
  cardDescription,
  uploadButtonOnly = false,
}: IUploadItem) => {
  const dispatch = useAppDispatch()

  const {
    uploadDocuments,
    // uploading,
  } = useDocumentUpload({
    documentCategory,
    documentType,
    additionalTrackingProperties,
    ...uploadProps,
  })

  const uploadedDocuments = useReselector(
    getUserDocumentsByCategoryInternalName,
    documentCategory
  )
  return (
    <div>
      <DocumentUploadDialog
        label={label}
        afterLabel={<Popup content={popUpContent} />}
        cardTitle={label}
        onUpload={uploadDocuments}
        hasTrigger
        cardDescription={cardDescription}
        uploadButtonOnly={uploadButtonOnly}
      >
        {children}
      </DocumentUploadDialog>

      <List>
        {uploadedDocuments.map((doc) => (
          <List.Item key={doc.id} className="flex items-center mb-2">
            {doc?.signedUrl ? (
              <Link
                href={doc.signedUrl}
                className="w-full"
                variant="primary"
                color={TextColors.MUTED}
              >
                {doc?.fileDescription}
              </Link>
            ) : (
              <Text variant={TypographyStyles.BODY_SM} color={TextColors.MUTED}>
                {doc?.fileDescription}
              </Text>
            )}

            <Icon
              icon={faTrashCan}
              onClick={() => dispatch(destroySingleUserDocument(doc.id))}
              className="ml-2 cursor-pointer"
              color="green"
            />
          </List.Item>
        ))}
      </List>
    </div>
  )
}
